module.exports = __webpack_public_path__ + "assets/img/effect_(8).e015b2fe.gif";